import React from 'react';

interface InfoItemProps {
  icon: React.ReactElement<{ className?: string }>;
  label: string;
  value: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ icon, label, value }) => (
  <div className="d-flex align-items-center">
    <div className="me-3 text-primary" style={{ height: '1.5rem', width: '1.5rem' }}>
      {React.cloneElement(icon, { className: 'w-100 h-100' })}
    </div>
    <div>
      <span className="small text-muted d-block">{label}</span>
      <span className="fw-semibold text-dark">{value}</span>
    </div>
  </div>
);

export default InfoItem;
